import locations from './store-locations.json';

export interface LatLong {
    lat: number;
    lng: number;
}

interface ZipLocation extends LatLong {
    zip: string;
}

export interface StoreData extends ZipLocation {
    storeId: string;
    city: string;
    state: string;
    brandName: string;
}

export interface NamedCluster {
    name: string;
    centroid: LatLong;
}

export interface StoreDataWithCluster extends StoreData {
    cluster: NamedCluster;
}

interface OutputFile {
    stores: Record<string, StoreDataWithCluster>;
    clusters: NamedCluster[];
}



// You could also just export the data directly if you prefer:
export const storeLocations: OutputFile = locations;
